import { render } from "./GroupManagementForm.vue?vue&type=template&id=3a0b0b54"
import script from "./js/groupManagementForm.js?vue&type=script&lang=js&external"
export * from "./js/groupManagementForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__